// extracted by mini-css-extract-plugin
export default {"tabletImg":"BM","desktopImg":"CM","mobileImg":"EM","backgroundImage":"FM","content":"GM","rtbLeft":"HM","rtbRight":"IM","imageContainer":"JM","rtbBox":"KM","line":"LM"};
    if(module.hot) {
      // 1715188237211
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  